import { HttpInterceptorFn } from '@angular/common/http';

import { isDesktop } from '~/core/helpers/device-utils';
import { DeviceType } from '~/core/constants/deviceType';
import { EnvironmentService } from '~/core/services/environment.service';

const tokenRequiredURLs: string[] = [EnvironmentService.backendURL, EnvironmentService.backendUserURL, EnvironmentService.transactionURL];

export const sourceInterceptor: HttpInterceptorFn = (req, next) => {
  if (isTokenRequiredForURL(req.url)) {
    req = req.clone({
      setHeaders: { 'ngx-source': isDesktop() ? DeviceType.DESKTOP : DeviceType.MOBILE },
    });
  }
  return next(req);
};

const isTokenRequiredForURL = (url: string): boolean => {
  return tokenRequiredURLs.some((base) => url?.includes(base));
};
